module.exports = __webpack_public_path__ + "img/migrate-emails.95430918.svg";